module.exports = __webpack_public_path__ + "static/media/BobaeMatchResized.4d17c87b.png";